<template>
    <div>
        <label style="font-size: 0.9em;">{{ label }}</label>
        <div class="container-fluid" style="padding: 0;">
            <div class="row">
                <div class="col">
                    <ui-datepicker v-model="selected" :picker-type="pickerType"
                            :custom-formatter="dateFormatter"
                            :date-filter="dateFilter"
                            @input="emitInput"
                            append-dropdown-to-body
                            :start-of-week="1"
                    ></ui-datepicker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Moment from 'moment';

    export default {
        created() {
            if (this.value !== '%') {
                this.selected = this.parseDate(this.value);
            } else {
                this.selected = null
            }
        },
        props: {
            pickerType: {
                type: String,
                default() {
                    return 'popover';
                }
            },
            value: {
                type: String,
                default() {
                    return '';
                }
            },
            label: {
                type: String,
                default: 'Date'
            },
            config: {
                type: Object,
                default() {
                    return {
                        selectionRestriction : false
                    };
                }
            },
        },
        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal && newVal.length > 0) {
                    this.selected = this.parseDate(newVal);
                } else {
                    this.selected = null
                }
            }
        },
        data() {
            return {
                selected: null
            }
        },
        methods: {
            emitInput() {
                if (this.selected) {
                    let string = Moment(this.selected).format()
                    this.$emit('input', string)
                    this.$emit('change', string)
                }
            },
            parseDate(str) {
                return (new Moment(str)).tz('UTC').toDate()
            },
            dateFormatter(date) {
                return (new Moment(date)).format('DD/MM/YYYY')
            },
            dateFilter(value) {
                if (value && this.config.selectionRestriction === 'firstDayOfMonth') {
                    return value.getDate() === 1
                }

                return true
            },
        },
    }
</script>